import {AfterViewInit, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';

@Component({
  selector: 'ui-expand-text',
  templateUrl: './expand-text.component.html',
  encapsulation: ViewEncapsulation.None

})
export class ExpandTextComponent implements OnInit{
  public language = language;
  @Input() contentText: String = '';
  public check: boolean = false;
  public shortText: String = '';
  @Input() sizeMax: number = 50;
  public expand : boolean = false;
  constructor(

  ) {

  }
  ngOnInit(): void {
    if (this.contentText.length > this.sizeMax)
    {
      this.check = true;
      this.shortText = this.contentText.substr( 0, this.sizeMax);
    }
  }
  public reload(content: String)
  {
      this.contentText = content;
      if (this.contentText.length > this.sizeMax)
      {
        this.check = true;
        this.shortText = this.contentText.substr( 0, this.sizeMax);
      }
  }
}
